import React, { useEffect } from 'react';
import { analyticsEventsTracker, EVENT_TRACKERS, GTMOnboardingFunnelEvent } from '../../../utils/analytics';
import { getParameterFromURL } from '../../../utils/scripts';
import { assignPDFHighPricesGroup } from '../../../utils/scripts/pdfHighPricesTest';
import locales from '../../../content.json';
import { getOptionDiscountLabel } from '../../../abtests/everydoggyV10/offer/helpers';
import { getPricesConfig } from '../../../abtests/getPricesConfig';

import imgAvif from './img/img.avif';
import imgJpg from './img/img.jpg';
import star from './img/star.png';

import s from './index.module.scss';

const MainScreen = () => {
  const lang = locales[window.userLang] ? window.userLang : 'en';
  const dict = locales[lang];
  const subscrUK = getParameterFromURL('subscrUK') === 'true';
  const tariff = getParameterFromURL('tariff');
  const version = subscrUK ? 'version2UK' : 'version2';
  const commandsLearned = getParameterFromURL('cn') || '3';
  const customV73 = getParameterFromURL('config') === 'customV73';
  const { extraOptions } = getPricesConfig(tariff);

  useEffect(() => {
    analyticsEventsTracker.trackWithTarget(GTMOnboardingFunnelEvent.showPaywall(version), EVENT_TRACKERS.GTM);
    assignPDFHighPricesGroup();
  }, [version]);

  return (
    <div className={s.wrapper}>
      <div className={s.content}>
        <div className={s.discountInfo}>
          <p className={s.discountText}>
            {locales[window.userLang].payment_text_312}
          </p>
          <div className={s.discountBadge}>{getOptionDiscountLabel(dict.promo_code_save, extraOptions?.discountPercent)}</div>
        </div>

        <h2 className={s.title}>{customV73 ? locales[window.userLang].payment_text_353 : locales[window.userLang].payment_text_314}</h2>

        <div className={s.subtitle}>
          <img src={star} alt="" aria-hidden="true" />
          <p>{locales[window.userLang].payment_text_315}</p>
        </div>

        <div className={s.comparisonCard}>
          <div className={s.imageWrapper}>
            <div className={`${s.imageBadge} ${s.imageBadgeNow}`}>{locales[window.userLang].payment_text_305}</div>
            <div className={`${s.imageBadge} ${s.imageBadgeEverydoggy}`}>{locales[window.userLang].payment_text_175}</div>

            <picture>
              <source srcSet={imgAvif} type="image/avif" />
              <img
                className={s.image}
                src={imgJpg}
                alt="Training comparison showing life before and with EveryDoggy"
              />
            </picture>
          </div>

          <div className={s.comparisonContent}>
            <div className={s.column}>
              <div className={s.stat}>
                <span className={s.statLabel}>{locales[window.userLang].payment_text_316}</span>
                <span className={s.statValue}>{commandsLearned}</span>
              </div>

              <div className={s.separator} />

              <div className={s.stat}>
                <span className={s.statLabel}>{locales[window.userLang].payment_text_317}</span>
                <span className={s.statValue}>{locales[window.userLang].payment_text_318}</span>
              </div>

              <div className={s.progress}>
                <span className={`${s.progressBar} ${s.progressBarOrange}`} />
                <span className={`${s.progressBar} ${s.progressBarOrangeMuted}`} />
                <span className={`${s.progressBar} ${s.progressBarOrangeMuted}`} />
              </div>
            </div>

            <div className={s.column}>
              <div className={s.stat}>
                <span className={s.statLabel}>{locales[window.userLang].payment_text_316}</span>
                <span className={s.statValue}>50+</span>
              </div>

              <div className={s.separator} />

              <div className={s.stat}>
                <span className={s.statLabel}>{locales[window.userLang].payment_text_317}</span>
                <span className={s.statValue}>{locales[window.userLang].payment_text_319}</span>
              </div>

              <div className={s.progress}>
                <span className={`${s.progressBar} ${s.progressBarPurple}`} />
                <span className={`${s.progressBar} ${s.progressBarPurple}`} />
                <span className={`${s.progressBar} ${s.progressBarPurple}`} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { MainScreen };
export default MainScreen;
